import { Expose } from 'class-transformer';

export class Facility {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  city!: string;

  @Expose({ name: 'postal_code' })
  postalCode!: string;

  @Expose()
  province!: string;

  @Expose()
  street!: string;

  @Expose({ name: 'street_number' })
  streetNumber!: string;

  @Expose({ name: 'formatted_address' })
  address!: string;

  @Expose({ name: 'gmb_address_id' })
  gmbAddressId!: number;

  @Expose({ name: 'write_review_url' })
  writeReviewUrl!: string;
}
